const light = '#19BAB8'
const main = '#009C9C'
const dark = '#11817F'

export default {
  light,
  main,
  dark,
  50: '#F1FBFC',
  100: '#41E3E2',
  200: light,
  250: main,
  300: dark,
  400: '#006663',
  500: '#014846',
  600: '#004f4f',
}
